<template>
  <div>
    <h3>Personal Information</h3>
    <Input
      @enter="next"
      :inputField="inputs.fn"
      inputName="First Name"
      inputType="name"
    />
    <Input
      @enter="next"
      :inputField="inputs.ln"
      inputName="Last Name"
      inputType="name"
    />
    <Dropdown
      v-show="show_job_title == true"
      @enter="next"
      :inputField="inputs.title"
      inputName="Your Job Title"
      inputType="string"
      :options="titleOptions"
    />
    <Input
      @enter="next"
      :inputField="inputs.ownership"
      inputName="Ownership Percentage"
      inputType="percent"
      :range="[1, 100]"
      :icons="{ right: 'fa-percent' }"
    />
    <Input
      @enter="next"
      :inputField="inputs.email"
      inputName="Business Email Address"
      inputType="email"
      :icons="{ right: 'fa-envelope' }"
    />
    <Input
      @enter="next"
      :inputField="inputs.phone"
      inputName="Cell Phone"
      inputType="phone"
      :icons="{ right: 'fa-mobile-alt' }"
    />
    <h4 style="color: #3273dc; margin-top: 32px; margin-bottom: 20px">
      We're great at texting!
    </h4>
    <div
      style="display: inline-block; font-size: 14px; margin-bottom: 5px"
      class="disclosure_radio"
    >
      <label class="form-control">
        <input
          class="radio"
          type="radio"
          name="sms-opt-in"
          v-model="inputs.smsOptIn"
          value="1"
        />
        By selecting this button you agree to receive account updates and
        promotional messages from 227343, message frequency varies. Text HELP to
        227343 to get help, or STOP to 227343 to stop, Message and Data Rates
        may apply. By opting in, you authorize the seller to deliver messages
        using an automatic telephone dialing system and you understand that you
        are not required to opt in as a condition of purchasing any property,
        goods, or services.
      </label>
    </div>

    <p
      style="font-size: 14px; margin-bottom: 5px"
      class="disclosure_radio"
      for="yes"
    >
      <label class="form-control">
        <input
          class="radio"
          type="radio"
          name="sms-opt-in"
          v-model="inputs.smsOptIn"
          value="0"
        />Please don't opt me in for SMS messages at this time
      </label>
    </p>
    <br />
    <div class="buttons is-right">
      <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
      <a class="button is-link padded-button next-button" @click="next"
        >Continue</a
      >
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import Dropdown from "@/components/shared/Dropdown";
import ApplyPage from "@/components/shared/ApplyPage";

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "PersonalInfo",
  components: {
    Input,
    Dropdown,
  },
  props: {
    toggle_job_title: Boolean,
  },
  mixins: [ApplyPage],
  data() {
    return {
      obj: "pg",
      inputs: {
        fn: Input.model(),
        ln: Input.model(),
        title: Input.model(),
        ownership: Input.model(),
        email: Input.model(),
        phone: Input.model(),
        smsOptIn: "",
      },
      titleOptions: [
        "Administrator",
        "CEO",
        "COO",
        "Co-Owner",
        "Director",
        "Founder",
        "General Manager",
        "Owner",
        "Manager",
        "Managing Member",
        "Member",
        "President",
        "Partner",
        "Other",
      ],
      show_job_title: false,
    };
  },
  mounted: function () {
    let selected_classification = getWithExpiry("classification");
    if (selected_classification === "Sole Proprietorship") {
      this.inputs.title.value = "Owner";
    } else if (selected_classification === "Partnership") {
      this.inputs.title.value = "Partner";
    } else if (selected_classification === "LLC") {
      this.inputs.title.value = "Managing Member";
    } else if (
      selected_classification === "C Corporation" ||
      selected_classification === "S Corporation"
    ) {
      this.inputs.title.value = "President";
    } else {
      this.inputs.title.value = "Owner";
    }
    this.show_job_title = false;
    if (this.toggle_job_title) {
      this.show_job_title = this.toggle_job_title;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.disclosure_radio {
  font-size: 0.76470588rem;
  line-height: 1.25;
  display: block;
}
input[type="radio"] {
  /* transform: scale(2);  */
  width: 16px;
  height: 16px;
  outline: gray;
}
.form-control {
  /* font-family: system-ui, sans-serif;
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.1; */
  display: grid;
  grid-template-columns: 1em auto;
  gap: 8px;
}
</style>
